import { HeaderToggle } from "@medme/layout"
import { Separator } from "@medme/ui"
import { HeaderBreadcrumb } from "./HeaderBreadcrumb"

/**
 * Main header component with sidebar toggle and breadcrumb
 * Left section: toggle button, separator, breadcrumb
 * Right section: reserved for future actions (currently empty)
 */
export function Header() {
	return (
		<header className="flex items-center h-16 px-4 border-b bg-background">
			<div className="flex items-center gap-4 flex-1">
				<HeaderToggle />
				<Separator orientation="vertical" className="h-8" />
				<HeaderBreadcrumb />
			</div>
			{/* Right section reserved for future actions */}
			<div className="ml-auto"></div>
		</header>
	)
}
